// extracted by mini-css-extract-plugin
module.exports = {"purchaseOrderDetailsContainer":"PurchaseOrderDetails_purchaseOrderDetailsContainer__2WlTT"};